import { useState } from 'react';
import {
    Modal,
    Form,
    FormField,
    Checkbox,
    Button,
    Message,
    Divider,
} from 'semantic-ui-react';
import { IcctDatePicker } from '../../common/IcctDatePicker';
import { exportRoadblocks } from './roadblockService';
import { formatDateToYyyyMmDd } from '../../../utils/formatDate';

export const ExportModal = ({ open, onClose, onExportSuccess }) => {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [includeOpen, setIncludeOpen] = useState(true);
    const [includeResolved, setIncludeResolved] = useState(true);
    const [exporting, setExporting] = useState(false);
    const [error, setError] = useState('');

    const handleClose = () => {
        setStartDate(null);
        setEndDate(null);
        setIncludeOpen(true);
        setIncludeResolved(true);
        setError('');
        onClose();
    };

    const handleExport = async () => {
        if (!includeOpen && !includeResolved) {
            setError('Please select at least one roadblock status to export.');
            return;
        }
        setExporting(true);
        setError('');
        try {
            const status = !includeOpen ? 'resolved' : !includeResolved ? 'open' : undefined;

            await exportRoadblocks({
                status,
                start_date: startDate ? formatDateToYyyyMmDd(startDate) : undefined,
                end_date: endDate ? formatDateToYyyyMmDd(endDate) : undefined,
            });
            handleClose();
            if (onExportSuccess) onExportSuccess();
        } catch (err) {
            setError(err.message);
        } finally {
            setExporting(false);
        }
    };

    return (
        <Modal open={open} onClose={handleClose} size="small">
            <Modal.Header>Export Roadblock Data</Modal.Header>
            <Modal.Content>
                <p style={{ color: '#666' }}>
                    Select a date range and status to export roadblock data as a CSV file.
                </p>

                {error && <Message negative>{error}</Message>}

                <Form>
                    <Form.Group widths="equal">
                        <FormField>
                            <label>Start Date</label>
                            <IcctDatePicker
                                keyName="startDate"
                                value={startDate}
                                onChange={(key, value) => setStartDate(value)}
                            />
                        </FormField>
                        <FormField>
                            <label>End Date</label>
                            <IcctDatePicker
                                keyName="endDate"
                                value={endDate}
                                onChange={(key, value) => setEndDate(value)}
                            />
                        </FormField>
                    </Form.Group>

                    <Divider />

                    <FormField>
                        <label>Roadblock Status</label>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', marginTop: '0.5rem' }}>
                            <div>
                                <Checkbox
                                    label="Open Roadblocks"
                                    checked={includeOpen}
                                    onChange={(e, { checked }) => setIncludeOpen(checked)}
                                />
                                <div style={{ color: '#666', fontSize: '0.85em', marginLeft: '1.85rem' }}>
                                    Active roadblocks not yet resolved
                                </div>
                            </div>
                            <div>
                                <Checkbox
                                    label="Resolved Roadblocks"
                                    checked={includeResolved}
                                    onChange={(e, { checked }) => setIncludeResolved(checked)}
                                />
                                <div style={{ color: '#666', fontSize: '0.85em', marginLeft: '1.85rem' }}>
                                    Closed and marked as resolved
                                </div>
                            </div>
                        </div>
                    </FormField>
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={handleClose} disabled={exporting}>
                    Cancel
                </Button>
                <Button
                    primary
                    onClick={handleExport}
                    loading={exporting}
                    disabled={exporting || (!includeOpen && !includeResolved)}
                >
                    Export
                </Button>
            </Modal.Actions>
        </Modal>
    );
};
